const getSubStringByLength = (string: string, length: number) => {
  if (string.length <= length) {
    return string;
  } else {
    return string.substring(0, length) + "...";
  }
};

export default getSubStringByLength;
